export const categories = [
  { name: 'Shoes', url: 'https://kaspreadsheet.com/category-911-Shoes.html', imageSeq: 'cat-shoes-v2' },
  { name: 'Hoodies/Sweaters', url: 'https://kaspreadsheet.com/search-912/name/Shoes.html', imageSeq: 'cat-hoodies-v2' },
  { name: 'T-Shirts', url: 'https://kaspreadsheet.com/search-913/name/Shoes.html', imageSeq: 'cat-tshirts-v2' },
  { name: 'Jackets', url: 'https://kaspreadsheet.com/search-914/name/Shoes.html', imageSeq: 'cat-jackets-v2' },
  { name: 'Pants/Shorts', url: 'https://kaspreadsheet.com/search-915/name/Shoes.html', imageSeq: 'cat-pants-v2' },
  { name: 'Headwear', url: 'https://kaspreadsheet.com/search-916/name/Shoes.html', imageSeq: 'cat-headwear-v2' },
  { name: 'Sets', url: 'https://kaspreadsheet.com/search-917/name/Shoes.html', imageSeq: 'cat-sets-v2' },
  { name: 'Unterwäsche/Unterhosen', url: 'https://kaspreadsheet.com/search-918/name/Shoes.html', imageSeq: 'cat-underwear-v2' },
  { name: 'Jersey', url: 'https://kaspreadsheet.com/search-919/name/Shoes.html', imageSeq: 'cat-jersey-v2' },
  { name: 'Accessories', url: 'https://kaspreadsheet.com/search-920/name/Shoes.html', imageSeq: 'cat-accessories-v2' },
  { name: 'Bags', url: 'https://kaspreadsheet.com/search-921/name/Shoes.html', imageSeq: 'cat-bags-v2' },
  { name: 'Belts', url: 'https://kaspreadsheet.com/search-922/name/Shoes.html', imageSeq: 'cat-belts-v2' },
  { name: 'Perfumes', url: 'https://kaspreadsheet.com/search-923/name/Shoes.html', imageSeq: 'cat-perfumes-v2' },
  { name: 'Other Stuff', url: 'https://kaspreadsheet.com/search-924/name/Shoes.html', imageSeq: 'cat-other-v2' },
];

export const faqData = [
  {
    question: 'Was ist das OOPBuy Spreadsheet?',
    answer: 'Das OOPBuy Spreadsheet ist ein umfassendes Produktverzeichnis, das tausende von geprüften Artikeln aus verschiedenen Kategorien wie Sneaker, Hoodies, Jacken und Accessoires auflistet. Es ermöglicht dir, schnell Produkte zu finden, Verkäufer zu vergleichen und direkt zu den Shops zu gelangen – alles an einem zentralen Ort.',
  },
  {
    question: 'Ist das OOPBuy Spreadsheet kostenlos?',
    answer: 'Ja, der Zugang zum OOPBuy Spreadsheet ist völlig kostenlos. Du kannst das Spreadsheet ohne Registrierung öffnen und sofort mit dem Stöbern beginnen. Es fallen keine versteckten Gebühren oder Abonnementkosten an.',
  },
  {
    question: 'Wie funktioniert die Qualitätskontrolle (QC)?',
    answer: 'Die im Spreadsheet aufgeführten Verkäufer und Produkte werden regelmäßig überprüft. Viele Einträge enthalten QC-Fotos, die den tatsächlichen Zustand der Produkte zeigen. So kannst du vor dem Kauf sicher sein, dass die Qualität deinen Erwartungen entspricht.',
  },
  {
    question: 'Kann ich auch aus Deutschland bestellen?',
    answer: 'Absolut! Das OOPBuy Spreadsheet ist speziell für den deutschen Markt optimiert. Die aufgeführten Verkäufer bieten Versand nach Deutschland an, und du findest Informationen zu Versandoptionen, Lieferzeiten und Zollbestimmungen direkt in den Produkteinträgen.',
  },
  {
    question: 'Wie oft wird das Spreadsheet aktualisiert?',
    answer: 'Das OOPBuy Spreadsheet wird kontinuierlich aktualisiert. Neue Produkte, aktuelle Preise und neue Verkäufer werden regelmäßig hinzugefügt, damit du immer Zugriff auf die neuesten Angebote hast. Es lohnt sich, regelmäßig vorbeizuschauen.',
  },
];

export const testimonialData = {
  name: 'Markus K.',
  role: 'Zufriedener Nutzer aus Berlin',
  text: 'Das OOPBuy Spreadsheet hat meine Art einzukaufen komplett verändert. Ich finde jetzt in wenigen Minuten, wofür ich früher stundenlang gesucht habe. Die Qualität der Produkte ist durchweg top, und der direkte Link zu den Shops spart mir unglaublich viel Zeit.',
  rating: 4.9,
};

export const benefitsData = [
  {
    title: 'QC Fotos',
    description: 'Echte Produktfotos von geprüften Verkäufern – du siehst genau, was du bekommst, bevor du bestellst.',
    icon: 'ri-camera-lens-line',
    imageSeq: 'benefit-qc-v2',
  },
  {
    title: 'Verkäufer-Vergleich',
    description: 'Vergleiche verschiedene Verkäufer auf einen Blick und finde das beste Preis-Leistungs-Verhältnis für dein Wunschprodukt.',
    icon: 'ri-scales-line',
    imageSeq: 'benefit-compare-v2',
  },
  {
    title: 'Schnelle Navigation',
    description: 'Durchsuche tausende Produkte in Sekundenschnelle mit der intelligenten Kategorisierung und Filterfunktion.',
    icon: 'ri-flashlight-line',
    imageSeq: 'benefit-speed-v2',
  },
];

export const articleData = [
  {
    title: 'OOPBuy Spreadsheet für Anfänger – Der komplette Guide 2026',
    slug: 'oopbuy-spreadsheet-guide',
    excerpt: 'Alles, was du als Einsteiger über das OOPBuy Spreadsheet wissen musst: Von der ersten Nutzung bis zum erfolgreichen Einkauf.',
    imageSeq: 'article-guide-v2',
    category: 'Guide',
  },
  {
    title: 'Die besten Sneaker im OOPBuy Spreadsheet finden',
    slug: 'beste-sneaker',
    excerpt: 'Entdecke die angesagtesten Sneaker-Modelle und lerne, wie du sie schnell im Spreadsheet findest.',
    imageSeq: 'article-sneaker-v2',
    category: 'Kategorie',
  },
  {
    title: 'QC Fotos richtig lesen – Qualitätscheck leicht gemacht',
    slug: 'qc-fotos-guide',
    excerpt: 'So interpretierst du QC-Fotos korrekt und erkennst hochwertige Produkte auf den ersten Blick.',
    imageSeq: 'article-qc-v2',
    category: 'Guide',
  },
  {
    title: 'Versand nach Deutschland – Alles zu Kosten & Zoll',
    slug: 'versand-deutschland',
    excerpt: 'Komplette Übersicht zu Versandoptionen, Lieferzeiten und Zollbestimmungen für deutsche Käufer.',
    imageSeq: 'article-shipping-v2',
    category: 'Versand',
  },
  {
    title: 'Nike im OOPBuy Spreadsheet – Alle Modelle & Angebote',
    slug: 'brand-nike',
    excerpt: 'Von Air Force 1 bis Dunk Low: So findest du die besten Nike-Sneaker im Spreadsheet zu Top-Preisen.',
    imageSeq: 'article-nike-v2',
    category: 'Marken',
  },
  {
    title: 'Adidas im OOPBuy Spreadsheet – Samba, Gazelle & mehr',
    slug: 'brand-adidas',
    excerpt: 'Adidas Klassiker und neue Modelle clever im Spreadsheet navigieren – unser Marken-Guide für Deutschland.',
    imageSeq: 'article-adidas-v2',
    category: 'Marken',
  },
  {
    title: 'Yupoo Einkaufsführer – So findest du versteckte Angebote',
    slug: 'yupoo-guide',
    excerpt: 'Der ultimative Guide zur Nutzung von Yupoo in Kombination mit dem OOPBuy Spreadsheet für deutsche Käufer.',
    imageSeq: 'article-yupoo-v2',
    category: 'Plattform',
  },
  {
    title: 'Taobao für Deutsche – Einkaufen mit dem Spreadsheet',
    slug: 'taobao-guide',
    excerpt: 'Schritt-für-Schritt-Anleitung: So navigierst du Taobao mit dem OOPBuy Spreadsheet und findest die besten Deals.',
    imageSeq: 'article-taobao-v2',
    category: 'Plattform',
  },
  {
    title: 'Beste Hoodies & Sweaters im OOPBuy Spreadsheet',
    slug: 'beste-hoodies',
    excerpt: 'Von Essentials bis Balenciaga: Die angesagtesten Hoodies, die du im Spreadsheet entdecken kannst.',
    imageSeq: 'article-hoodies-v2',
    category: 'Kategorie',
  },
  {
    title: 'Beste Jacken & Mäntel – Winterkollektion im Spreadsheet',
    slug: 'beste-jacken',
    excerpt: 'Warme Jacken für den deutschen Winter: Von The North Face bis Moncler – alle Top-Marken im Überblick.',
    imageSeq: 'article-jacken-v2',
    category: 'Kategorie',
  },
  {
    title: 'Sicher einkaufen mit OOPBuy – Betrug erkennen & vermeiden',
    slug: 'sicher-einkaufen',
    excerpt: 'So schützt du dich vor Fake-Verkäufern: Sicherheitstipps für risikofreies Einkaufen mit dem OOPBuy Spreadsheet.',
    imageSeq: 'article-safety-v2',
    category: 'Guide',
  },
  {
    title: '1688.com Guide – Großhandelspreise für Deutschland',
    slug: '1688-guide',
    excerpt: 'Wie du mit dem OOPBuy Spreadsheet die besten 1688-Angebote findest und nach Deutschland liefern lässt.',
    imageSeq: 'article-1688-v2',
    category: 'Plattform',
  },
  {
    title: 'Designer Bags im OOPBuy Spreadsheet entdecken',
    slug: 'designer-bags',
    excerpt: 'Hochwertige Taschen von Luxusmarken zu erschwinglichen Preisen – so navigierst du die Bag-Kategorie.',
    imageSeq: 'article-bags-v2',
    category: 'Kategorie',
  },
];